// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pages-catalog-__slug-indexstyleGrid-container-raiwi{margin:0 auto;max-width:1536px;padding:0 12px;width:100%}.pages-catalog-__slug-indexstyleGrid-grid-etlkf{display:grid;grid-gap:24px;grid-template-columns:repeat(12,1fr)}.pages-catalog-__slug-indexstyleGrid-col6-bbtoo{grid-column:span 6}.pages-catalog-__slug-indexstyleGrid-col3-betdk{grid-column:span 3}.pages-catalog-__slug-indexstyleGrid-col4-bjnuz{grid-column:span 4}.pages-catalog-__slug-indexstyleGrid-col9-xchid{grid-column:span 9}.pages-catalog-__slug-indexstyleGrid-col12-bvowc{grid-column:span 12}.pages-catalog-__slug-indexstyleGrid-alignItemsStart-bytom{align-items:start}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "pages-catalog-__slug-indexstyleGrid-container-raiwi",
	"grid": "pages-catalog-__slug-indexstyleGrid-grid-etlkf",
	"col6": "pages-catalog-__slug-indexstyleGrid-col6-bbtoo",
	"col3": "pages-catalog-__slug-indexstyleGrid-col3-betdk",
	"col4": "pages-catalog-__slug-indexstyleGrid-col4-bjnuz",
	"col9": "pages-catalog-__slug-indexstyleGrid-col9-xchid",
	"col12": "pages-catalog-__slug-indexstyleGrid-col12-bvowc",
	"alignItemsStart": "pages-catalog-__slug-indexstyleGrid-alignItemsStart-bytom"
};
module.exports = ___CSS_LOADER_EXPORT___;
